import debouce from 'lodash.debounce';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { P3 } from '../../styles/FontStyles';
import { UserImageCircle } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { Icon, IconSearch } from '../../styles/Icons';
import { getRootTeamMember } from './myTeamBackOffice.actions';
import { searchTeamMembersAsync } from './myTeamBackOffice.requests';
import { StructureType } from './myTeamBackOffice.constants';

export const SearchTeamMemberInput = ({ tab }) => {
  const { t } = useTranslation('myTeam');
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [members, setMembers] = useState([]);

  const handleChange = async (e) => {
    setMembers([]);
    // const _searchTerm = e.target.value;
    setSearchTerm(e.target.value);

    let x = await searchTeamMembersAsync({
      searchTerm: e.target.value
    });

    setIsModalOpen(true);

    setMembers(x?.data?.data?.users ?? []);
  };

  const debouncedResults = useMemo(() => {
    return debouce(handleChange, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  useEffect(() => {
    window.addEventListener('click', function () {
      setIsModalOpen(false);
    });
  }, []);

  const setRootTeamMember = (id) => {
    const structureType =
      tab === 'structure' ? StructureType.TEAM : StructureType.TRADING;
    dispatch(getRootTeamMember(id, structureType));
  };

  return (
    <div
      style={{
        position: 'relative'
        // width: 280,
      }}
      onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          backgroundColor: color.colors.neutral50,
          padding: 10,
          height: 43,
          borderRadius: 100,
          display: 'flex',
          marginBottom: '10px',
          width: 220,
          minWidth: window.innerWidth > 800 ? 220 : '',
          boxShadow: color.shadows.shadowXS
        }}>
        <div
          style={{
            width: 17,
            marginLeft: 10,
            marginRight: 5,
            position: 'relative',
            top: 2
          }}>
          <Icon color={color.colors.neutral700}>
            <IconSearch />
          </Icon>
        </div>
        <input
          style={{
            backgroundColor: 'rgba(0,0,0,0)',
            border: 0,
            height: 20,
            caretColor: color.colors.neutral0,
            color: color.colors.neutral900,
            fontSize: 14,
            width: '100%'
          }}
          onFocus={() => setIsModalOpen(true)}
          type='text'
          placeholder={t('search_placeholder')}
          onChange={debouncedResults}
        />
      </div>
      {isModalOpen && searchTerm.length > 0 && (
        <div
          style={{
            color: color.colors.neutral900,
            backgroundColor: color.colors.neutral50,
            width: '100%',
            borderRadius: 8,
            padding: 20,
            paddingBottom: 5,
            marginTop: 4,
            position: 'absolute',
            zIndex: 999,
            maxHeight: 270,
            overflow: 'hidden',
            overflowY: 'auto',
            boxShadow: color.shadows.shadowXS
          }}>
          {members.length > 0 ? (
            members.map((member, i) => (
              <div
                className='m-m'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 15,
                  cursor: 'pointer'
                }}
                key={i}
                onClick={() => setRootTeamMember(member.id)}>
                <UserImageCircle
                  image={member.profileImageUrl}
                  avatar
                  size='20px'
                  avatarSize='10px'
                  margin='0 15px 0 0'
                />

                <P3 color={color.colors.neutral900}>
                  {`${member.username ?? '---'} (#${member.id})`}
                </P3>
              </div>
            ))
          ) : (
            <div style={{ marginBottom: 15 }}>
              <P3 color={color.colors.neutral900}>
                {t('we_did_not_find_any_member')}
              </P3>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
